import React from 'react';
import { SvgIcon } from '@material-ui/core';
const Logout = (props) => (React.createElement(SvgIcon, Object.assign({ style: { fill: 'none', stroke: '#5f6165' } }, props, { viewBox: "0 0 20 21" }),
    React.createElement("path", { d: "M7.5 18.1055H4.16667C3.72464 18.1055 3.30072 17.9299 2.98816 17.6173C2.67559 17.3048 2.5 16.8808 2.5 16.4388V4.77214C2.5 4.33011 2.67559 3.90618 2.98816 3.59362C3.30072 3.28106 3.72464 3.10547 4.16667 3.10547H7.5" }),
    React.createElement("path", { d: "M13.333 14.7722L17.4997 10.6055L13.333 6.43884" }),
    React.createElement("path", { d: "M17.5 10.6055H7.5" })));
export default Logout;
